export const isEmptyValue = (value: unknown) => {
   if (value === null || value === undefined) return true
   if (typeof value === 'string') return value === ''
   if (Array.isArray(value)) return value.length === 0
   return false
}

export const isEmail = (email: string) => {
   const regex = /^[\w\-\.+]+@([\w-]+\.)+[\w-]{2,4}$/

   if (!regex.test(email)) {
      return 'form.error.invalid-email'
   }
}

export const passwordValid = (value: string) => {
   if (value.length < 6) {
      return 'form.error.password-too-short'
   }
}

export const isFiscalCode = (value: string) => {
   const regex = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i

   if (!regex.test(value)) {
      return 'form.error.fiscal-code-invalid'
   }
}

export const dependsOn = (value: any, dependence: boolean) => {
   if (!value && dependence) {
      return 'form.error.field-required'
   }
}

export const isUrl = (value: string) => {
   const regex = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?$/

   if (!regex.test(value)) {
      return 'form.error.invalid-url'
   }
}

export const isPhone = (value: string) => {
   const regex = /^\+?[0-9\s\-()]+$/

   if (!regex.test(value)) {
      return 'form.error.invalid-phone'
   }
}

export const isRestrictive = (
   value: number,
   direction: 'up' | 'down',
   parentValue?: number | null
) => {
   if (parentValue === null || parentValue === undefined) return

   if (isEmptyValue(value)) return 'form.error.field-required'

   if (direction === 'up' && value > parentValue) {
      return 'form.error.restrictive-up'
   } else if (direction === 'down' && value < parentValue) {
      return 'form.error.restrictive-down'
   }
}

export const isGt = (value: number, compareValue: number) => {
   if (!value || !compareValue) return

   if (value <= compareValue) {
      return 'form.error.greater-than'
   }
}

export const isLt = (value: number, compareValue: number) => {
   if (!value || !compareValue) return

   if (value >= compareValue) {
      return 'form.error.less-than'
   }
}

export const isDateBirth = (value: string) => {
   const date = new Date(value)
   if (Number.isNaN(date.getTime())) return 'form.error.date-birth-invalid'

   const now = new Date()
   const oldest = new Date(now.getFullYear() - 120, now.getMonth(), now.getDate())
   const youngest = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate())

   if (date < oldest || date > youngest) return 'form.error.date-birth-invalid'
}
